import React from 'react';
import { LuIndianRupee } from 'react-icons/lu';
import { useDisplayPrivacy } from '../contexts/DisplayPrivacyContext';
import { randomizeDisplayAmount } from '../utils/amountRandomizer';
import { MOCK_CURRENCY_SYMBOL } from '../utils/formatters';

interface CurrencyDisplayProps {
  amount: number | undefined | null;
  className?: string;
  valueClassName?: string;
  symbolClassName?: string;
  currency?: string;
  compact?: boolean;
  showType?: boolean;
  showFraction?: boolean;
  smallRupeeSymbol?: boolean;
  type?: 'CREDIT' | 'DEBIT';
  showOnlyNegative?: boolean;
}

const CurrencyDisplay: React.FC<CurrencyDisplayProps> = ({ 
  amount,
  className = '',
  valueClassName,
  symbolClassName,
  showType = true,
  type,
  showFraction = true,
  smallRupeeSymbol = false,
  showOnlyNegative = false,
}) => {
  const { randomizeAmounts } = useDisplayPrivacy();

  if (amount === undefined || amount === null) {
    return <span className={className}>--.--</span>;
  }

  const displayAmount = randomizeAmounts ? randomizeDisplayAmount(amount) : amount;

  if (!type) {
    type = displayAmount < 0 ? 'DEBIT' : 'CREDIT';
  }

  const formattedAmount = new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: showFraction ? 2 : 0,
  }).format(Math.abs(displayAmount));

  return (
    <div className={`flex flex-row items-center text-muted-foreground ${className}`}>
        {showType && (showOnlyNegative ? type === 'DEBIT' : true) && <span className={`text-sm font-mono ${symbolClassName ?? ''}`}>{type === 'DEBIT' ? '-' : '+'}</span>}
        <div className={`flex flex-row ${smallRupeeSymbol ? 'items-start' : 'items-center'}`}>
            {randomizeAmounts ? (
              <span className={`font-medium leading-none ${smallRupeeSymbol ? 'text-[10px] mt-0.5 mr-0.5' : 'text-sm mr-0.5'} ${symbolClassName ?? ''}`}>
                {MOCK_CURRENCY_SYMBOL}
              </span>
            ) : (
              <LuIndianRupee className={`${smallRupeeSymbol ? 'text-xs mt-0.5' : 'p-0.5 -mx-0.5'} font-base ${symbolClassName ?? ''}`} />
            )}
            <span className={valueClassName ?? 'text-foreground'}>{formattedAmount}</span>
        </div>
    </div>
  );
};

export default CurrencyDisplay; 
